import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FhInputPasswordComponent } from './components/fh-input-password/fh-input-password.component';
import { PasswordModule } from 'primeng/password';
import { DividerModule } from 'primeng/divider';
import { FhFormControlPipe } from './helpers/pipes/fh-form-control.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { FhPasswordValidationPipe } from './helpers/pipes/fh-password-validation.pipe';
import { FhLabelModule } from '@fh-client-interaction-frontends/fh-label';

@NgModule({
  imports: [CommonModule, PasswordModule, DividerModule, FormsModule, ReactiveFormsModule, TranslateModule, FhLabelModule],
  declarations: [FhInputPasswordComponent, FhFormControlPipe, FhPasswordValidationPipe],
  exports: [FhInputPasswordComponent, FhFormControlPipe]
})
export class FhInputPasswordModule {}
